<style lang="scss" scoped>
</style>

<template>
    <nav id="sidebar" class="fixed top-0 flex flex-col w-full h-full z-[99999] text-secondary-400 text-sm sm:text-base xl:text-sm transition-all !duration-500" :class="!show ? 'opacity-0 pointer-events-none' : ''">
        <div class="h-full py-12 px-8 flex-grow z-[2000] bg-white w-[360px] max-w-[500px] sm:w-auto sm:min-w-[420px] -right-[500px] absolute top-0 transition-all !duration-500" :class="show ? '!right-0' : ''">
            <div class="h-full px-3">
                <div class="flex flex-col h-full px-0 mt-0">
                    <button type="button" class="absolute top-6 right-4 w-8 h-8 hover:opacity-80 transition-all" @click="show = false">
                        <img class="w-4 h-4" width="10" height="10" src="/images/svg/close.svg" alt="chiudi"/>
                    </button>
                    <div class="flex-grow overflow-auto">
                        <div class="text-left mt-2 mb-5 uppercase">
                            <span class="text-primary tracking-[.15rem] mb-5 text-center">{{$root.translateString('products_in_total')}}:&nbsp; <span>({{countProducts}})</span></span>
                        </div>
                        <div class="space-y-3">
                            <div class="w-full flex items-start" v-for="(item, key) in cart" :key="key">
                                <div class="w-16 h-16 md:w-18 md:h-18 flex-shrink-0 flex justify-center items-center bg-customGray-background/50 p-3">
                                    <img width="70" class="w-full h-full object-contain relative -top-1" :src="item.options.image" :alt="item.options.name" />
                                </div>
                                <div class="flex flex-col flex-grow pl-5">
                                    <div class="flex flex-grow pl-0 pt-0 w-full">
                                        <span class="pr-2 h-full whitespace-nowrap !leading-snug relative -top-0.5">{{item.qty}} x</span>
                                        <span class="flex-grow flex flex-col">
                                            <span class="uppercase text-black !leading-tight" v-text="item.options.name"></span>
                                            <span class="w-full flex flex-col !leading-snug text-customGray-text">
                                                <span class="w-full" v-if="item.options.type != 'visite'" v-text="item.options.combination"></span>
                                                <span class="w-full" v-else-if="item.options.type == 'visite'">
                                                    {{parseInt(item.options.visit.adults) + parseInt(item.options.visit.kids)}}
                                                    <span v-if="item.options.visit.adults==1">{{$root.translateString('person')}}</span>
                                                    <span v-else>{{$root.translateString('people')}}</span>
                                                    <span v-if="item.options.combination">
                                                        Distilleria Francesco
                                                    {{item.options.combination.replace(" ", "")}}
                                                    </span>
                                                </span>
                                                <span class="w-full" v-else> Distilleria Francesco </span>
                                            </span>
                                        </span>
                                    </div>
                                    <div class="py-0 flex items-center flex-grow mt-2 pl-0">
                                        <span class="flex-grow ">
                                            € {{ $root.currencyDisplaySimple(parseFloat(item.price) * parseInt(item.qty)) }}
                                        </span>
                                        <a class="inline-flex space-x-2 items-center text-customGray-text xl:hover:text-black transition-all" href="javascript:void(0)" @click="updateCart(key, 0)">
                                            <span class="">{{$root.translateString('remove')}}</span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="my-4 w-full bg-customGray-background/50 px-6 py-3 flex justify-center items-center">
                        <span class="text-black uppercase font-medium tracking-[.15rem] !text-xs xl:!text-xxs">{{$root.translateString('free_shipping')}} <span>€110</span></span>
                    </div>

                    <div class="pb-4 mb-4 text-center text-primary border-b border-secondary-400/20" v-if="missing_for_free_shipping > 0">
                       <span v-if="lang == 'it'">
                           Sei a € {{$root.currencyDisplaySimple(missing_for_free_shipping)}} dalla spedizione gratuita.
                       </span>
                        <span v-else>
                           € {{$root.currencyDisplaySimple(missing_for_free_shipping)}} left for free shipping.
                       </span>
                    </div>

                    <div class="flex pb-2">
                        <div class="flex-grow">{{$root.translateString('subtotal')}}</div>
                        <div class="">
                            € {{ $root.currencyDisplaySimple(priceTotalWt) }}
                        </div>
                    </div>

                    <div class="spedizione flex pb-4" v-if="should_be_shipped">
                        <div class="flex-grow">{{$root.translateString('shipping')}}</div>
                        <div class="">
                            <span v-if="shipping > 0">
                                 € {{ $root.currencyDisplaySimple(shipping) }}
                            </span>
                            <span v-else>{{$root.translateString('free')}}</span>
                        </div>
                    </div>

                    <div class="spedizione flex pb-4" v-if="discount > 0">
                        <div class="flex-grow">{{$root.translateString('discount')}}</div>
                        <div class="">
                            € {{ $root.currencyDisplaySimple(discount) }}
                        </div>
                    </div>

                    <div class="flex py-3 border-t border-secondary-400/20">
                        <div class="flex flex-grow flex-col">
                            <div class="">{{$root.translateString('total')}}</div>
                            <small class="-mt-1 text-customGray-text">{{$root.translateString('tax_included')}}</small>
                        </div>
                        <div class="text-black"> € {{ $root.currencyDisplaySimple(finalPrice) }} </div>
                    </div>

                    <div class="text-center w-full mt-4 pt-2 mb-2">
                        <div class="flex w-full">
                            <a :href="$root.langRoute('/carrello')" class="relative w-full lg:px-16 py-5 flex items-center bg-customGray-background transition-all !duration-500 mx-auto xl:hover:!rounded-lg group">
                                <span class="absolute w-full h-[calc(100%+1rem)] left-0 top-1/2 -translate-y-1/2 border border-customGray-border/80 rounded-lg pointer-events-none group-hover:h-full group-hover:w-full transition-all !duration-[400ms]"></span>
                        <span class="absolute h-full w-[calc(100%+1rem)] top-0 left-1/2 -translate-x-1/2 border border-customGray-border/80 rounded-lg pointer-events-none group-hover:h-full group-hover:w-full transition-all !duration-[400ms] group-hover:xl:opacity-0"></span>
                                <span class="text-black text-xs sm:text-sm xl:text-xs block w-full text-center uppercase tracking-[.11rem] font-medium">
                                    {{$root.translateString('go_to_cart')}}
                                </span>
                            </a>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div class="fixed top-0 left-0 w-full h-full z-1000" style="background-color:rgba(13, 13, 13, .82)" @click="show = false"></div>
    </nav>
</template>

<script>
    export default {
        props: ['lang'],
        data() {
            return {
                show:false,
                cartRaw: null,
                should_be_shipped: false,
                priceTotalWt: 0,
                finalPrice: 0,
                shipping: 0,
                discount: 0,
                missing_for_free_shipping: 0,
            }
        },
        mounted() {
            this.getCart();

            this.$eventHub.$on('cart.show', payload => {
                this.show = true;
            });

            this.$eventHub.$on('cart.added', payload => {
                this.getCart();
            });

            this.$eventHub.$on('cart.updated', payload => {
                this.getCart();
            });

        },
        methods: {
            setCookie(key, value, expiry) {
                let expires = new Date();
                expires.setTime(expires.getTime() + (expiry * 24 * 60 * 60 * 1000));
                document.cookie = key + '=' + value + ';expires=' + expires.toUTCString();
            },

            getCookie(key) {
                let keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
                return keyValue ? keyValue[2] : null;
            },
            emptyCart() {
                axios.post('/api/cart/empty', {})
                .then(response => {
                    this.cartRaw = null;
                    this.shipping = 0;
                    this.priceTotalWt = 0;
                    this.finalPrice = 0;
                    this.discount = 0;
                    this.missing_for_free_shipping = 0;
                })
            },
            updateCart(key, value) {

                axios.post('/api/cart/update', {
                    'key': key,
                    'qty': value,
                })
                .then(response => {
                    this.getCart();

                    let update_type = 'add';
                    let quantity_to_track = value;

                    if(quantity_to_track == 0) {

                        quantity_to_track = this.cart[key].qty;

                        dataLayer.push({ ecommerce: null });
                        dataLayer.push({
                            event: "remove_from_cart",
                            ecommerce: {
                                items: [
                                    {
                                        item_name: this.cart[key].options.name.replace('<br>', ' '),
                                        item_id: this.cart[key].id,
                                        price: String(this.cart[key].options.price).replace(',', '.'),
                                        item_brand: '',
                                        item_category: this.cart[key].options.type,
                                        item_variant: this.cart[key].options.combination.toLowerCase(),
                                        quantity: quantity_to_track
                                    }
                                ]
                            }
                        });

                    }else{

                        dataLayer.push({ ecommerce: null });
                        dataLayer.push({
                            event: "add_to_cart",
                            ecommerce: {
                                items: [
                                    {
                                        item_name: this.cart[key].options.name.replace('<br>', ' '),
                                        item_id: this.cart[key].id,
                                        price: String(this.cart[key].options.price).replace(',', '.'),
                                        item_brand: '',
                                        item_category: this.cart[key].options.type,
                                        item_variant: this.cart[key].options.combination.toLowerCase(),
                                        quantity: quantity_to_track
                                    }
                                ]
                            }
                        });

                    }

                    this.setCookie('cartIsFull', this.countProducts, '1');

                    this.$eventHub.$emit('cart.updated');
                    this.$eventHub.$emit('cart.updated.simpleQty', parseInt(response.data.count));
                })
            },
            getCart() {
                axios.get('/api/cart/get')
                .then(response => {
                    this.cartRaw = response.data.cart;
                    this.shipping = response.data.shipping;
                    this.priceTotalWt = response.data.priceTotalWt;
                    this.finalPrice = response.data.finalPrice;
                    this.discount = response.data.discount;
                    this.should_be_shipped = response.data.shouldBeShipped;
                    this.missing_for_free_shipping = response.data.missingForFreeShipping;

                    if(_.isEmpty(this.cart)) {
                        this.show = false;
                    }

                })
            },
            isNotEmpty(object) {
                return (_.isEmpty(object) === false);
            }
        },
        beforeDestroy() {
            this.$eventHub.$off('cart.added');
            this.$eventHub.$off('cart.show');
            this.$eventHub.$off('cart.updated');
            this.$eventHub.$off('cart.updated.simpleQty');
        },
        computed: {
            cart() {
                if(this.cartRaw == null) {
                    return null;
                }

                let tmp = {};
                for (const [key, value] of Object.entries(this.cartRaw)) {
                    if(typeof value.options.isDiscount == 'undefined' || value.options.isDiscount == false) {
                        tmp[key] = value;
                    }
                }

                return tmp;
            },
            countProducts() {

                if(!this.isNotEmpty(this.cart)) {
                    return 0;
                }

                let count = 0;

                for (let [key, item] of Object.entries(this.cart)) {
                    count += item.qty;
                };

                return count;
            }
        }
    }
</script>
